import {  BankDetails } from "../models/BankDetails";
import { BankKey } from "../models/BankKey";
import { Company } from "../models/Company";
import { HouseBank } from "../models/HouseBank";
import { PaymentMethod } from "../models/PaymentMethod";
import { Po } from "../models/Po";
import { ReconAC } from "../models/ReconAC";
import { RegionCode } from "../models/RegionCode";
import { ResponseObject } from "../models/ResponseObject";
import { SecondLevelCategory } from "../models/SecondLevelCategory";
import { VendorDetailBankDetailMeta } from "../models/VendorDetail/VendorDetailBankDetailMeta";
import { VendorDetailBasicMeta } from "../models/VendorDetail/VendorDetailBasicMeta";
import { VendorDetailContactMeta } from "../models/VendorDetail/VendorDetailContactMeta";
import { VendorDetailPaymentMeta } from "../models/VendorDetail/VendorDetailPaymentMeta";
import { VendorNominated } from "../models/VendorNominated";
import { VendorType } from "../models/VendorType";
import { WHTType } from "../models/WHTType";
import { VendorCreateState } from "../reducers/vendor/VendorCreateReducer";
import { VendorDetailState } from "../reducers/vendor/VendorDetailReducer";
import { AxiosConfig } from "./AxiosConfig";
import qs from "qs";
import { VendorTypeData } from "../constants/AppConstants";
import {CallOverVerificationState} from "../reducers/vendor/CallOverVerificationReducer"
import saveAs from "file-saver";


const getCompany = async (
  successCallback: (companyData: Array<Company>) => void,
  errorCallback: (error: Error) => void
) => {
  try {
    const resp = await AxiosConfig.get("/Vendor/GetCompany");
    successCallback(resp.data);
  } catch (err: any) {
    // Handle Error Here
    console.error(err);
    errorCallback(err);
  }
};

const getPO = async (
  companyCode: string,
  successCallback: (poData: Array<Po>) => void,
  errorCallback: (error: Error) => void
) => {
  try {
    const resp = await AxiosConfig.get("/Vendor/GetPO", {
      params: { companyCode: companyCode },
      paramsSerializer: function (params) {
        return qs.stringify(params, { arrayFormat: "repeat" });
      },
    });
    successCallback(resp.data);
  } catch (err: any) {
    // Handle Error Here
    console.error(err);
    errorCallback(err);
  }
};

const getVendorNominatedBy = async (
  successCallback: (vendorNominatedData: Array<VendorNominated>) => void,
  errorCallback: (error: Error) => void
) => {
  try {
    const resp = await AxiosConfig.get("/Vendor/GetVendorNominatedBy");
    successCallback(resp.data);
  } catch (err: any) {
    // Handle Error Here
    console.error(err);
    errorCallback(err);
  }
};

const getVendorTypes = async (
  successCallback: (vendorTypesData: Array<VendorType>) => void,
  errorCallback: (error: Error) => void
) => {
  try {
    const resp = await AxiosConfig.get("/Vendor/GetVendorTypes");
    //remove x0005, X008 from the list as requested in UAT
    let vendortypes = resp.data;
    if(vendortypes){
      vendortypes = vendortypes.filter((item:VendorType, i:number) => {
        return (item.code !== VendorTypeData.GoodsSupplier 
          && item.code !== VendorTypeData.OneTimeVendor 
          && item.code !== VendorTypeData.Plant);
      });
    }
    // for (let index = 0; index < vendortypes.length; index++) {
    //   const element = vendortypes[index];
      
    // }
    successCallback(vendortypes);
  } catch (err: any) {
    // Handle Error Here
    console.error(err);
    errorCallback(err);
  }
};

const getSecondLevelCategory = async (
  vendroType: string,
  successCallback: (secondCategoryData: Array<SecondLevelCategory>) => void,
  errorCallback: (error: Error) => void
) => {
  try {
    const resp = await AxiosConfig.get("/Vendor/GetSecondLevelCategry", {
      params: { accGroupCode: vendroType },
    });
    if(resp.data == ""){
      resp.data = [];
    }
    successCallback(resp.data);
  } catch (err: any) {
    // Handle Error Here
    console.error(err);
    errorCallback(err);
  }
};

const getReconAC = async (
  companyCode: string,
  vendroType: string,
  successCallback: (reconACData: Array<ReconAC>) => void,
  errorCallback: (error: Error) => void
) => {
  try {
    const resp = await AxiosConfig.get("/Vendor/GetReconAC", {
      params: { companyCode: companyCode, vendroType: vendroType },
      paramsSerializer: function (params) {
        return qs.stringify(params, { arrayFormat: "repeat" });
      },
    });
    successCallback(resp.data);
  } catch (err: any) {
    // Handle Error Here
    console.error(err);
    errorCallback(err);
  }
};

const createVendor = async (
  createVendorData: VendorCreateState,
  successCallback: (vendorData: VendorCreateState) => void,
  errorCallback: (error: Error) => void
) => {
  try {
    const resp = await AxiosConfig.post("/Vendor/SaveForm1", createVendorData);
    successCallback(resp.data);
  } catch (err: any) {
    // Handle Error Here
    console.error(err);
    errorCallback(err);
  }
};

const getVendorRequestData = async (
  requestNumber:string,
  vendorNo: string,
  coCode: string,
  poCode: string,
  isForForm2:boolean,
  successCallback: (vendorRequestData: VendorCreateState) => void,
  errorCallback: (error: Error) => void
) => {
  try {
    const resp = await AxiosConfig.get("/Vendor/GetForm1Data", {
      params: { requestNo: requestNumber, vendorNo: vendorNo, coCode: coCode, poCode: poCode, isForForm2: isForForm2 },
      paramsSerializer: function (params) {
        return qs.stringify(params, { arrayFormat: "repeat" });
      }
    });
    successCallback(resp.data);
  } catch (err: any) {
    // Handle Error Here
    console.error(err);
    errorCallback(err);
  }
};

const downloadPdf = async (
  requestNumber:string,
  successCallback: (getVendorData: VendorDetailState) => void,
  errorCallback: (error: Error) => void
) => {
  try {
    const resp = await AxiosConfig.get("Vendor/DownloadForm2PDF", {
      params: { requestNo: requestNumber },
      responseType: 'arraybuffer',
      paramsSerializer: function (params) {
        return qs.stringify(params, { arrayFormat: "repeat" });
      }
    });
    if(resp.data){
    const _blob = new Blob([resp.data], { type: resp.headers['content-type'] })
        const url = URL.createObjectURL(_blob)
        saveAs(_blob, "Vendor Request_"+ requestNumber+'.pdf');
        //window.open(url)
        successCallback(resp.data);
    }
  } catch (err: any) {
    // Handle Error Here
    console.error(err);
    errorCallback(err);
  }
};

const getVendorDetailData = async (
  requestId:number, 
  vendorNo: string,
  coCode: string, 
  poCode: string,
  successCallback: (getVendorData: VendorDetailState) => void,
  errorCallback: (error: Error) => void
) => {
  try {
    const resp = await AxiosConfig.get("Vendor/GetForm2Data", {
      params: { requestId: requestId, vendorNo:vendorNo, coCode:coCode, poCode:poCode},
      paramsSerializer: function (params) {
        return qs.stringify(params, { arrayFormat: "repeat" });
      }
    });
    successCallback(resp.data);
  } catch (err: any) {
    // Handle Error Here
    console.error(err);
    errorCallback(err);
  }
};

const updateVendor = async (
  updateVendorData:VendorDetailState,
  successCallback: (vendorData: ResponseObject) => void,
  errorCallback: (error: Error) => void
) => {
  try {
    const resp = await AxiosConfig.post("/Vendor/SaveForm2", updateVendorData);
    successCallback(resp.data);
  } catch (err: any) {
    // Handle Error Here
    console.error(err);
    errorCallback(err);
  }
};

const submitVendor = async (
  requestId: number,
  successCallback: (vendorData: ResponseObject) => void,
  errorCallback: (error: Error) => void
) => {
  try {
    const resp = await AxiosConfig.post(
      "/Vendor/SubmitRequest",
      requestId
    );
    successCallback(resp.data);
  } catch (err: any) {
    // Handle Error Here
    console.error(err);
    errorCallback(err);
  }
};

const GetCallOverVerificationData = async (requestId:number,
  successCallback: (callOverVerification: CallOverVerificationState) => void,
  errorCallback: (error: Error) => void
) => {
  try {
    const resp = await AxiosConfig.get(`/Vendor/GetCallOverVerification?requestId=${requestId}`);
    successCallback(resp.data);
  } catch (err: any) {
    // Handle Error Here
    console.error(err);
    errorCallback(err);
  }
};

export const VendorDetailService = {
  getCompany,
  getPO,
  getVendorNominatedBy,
  getVendorTypes,
  getSecondLevelCategory,
  getReconAC,
  getVendorRequestData,
  downloadPdf,
  createVendor,
  getVendorDetailData,
  updateVendor,
  GetCallOverVerificationData,
  submitVendor
};
